import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { Alert } from '@app/alerts/state/alerts-state.models';
import { defaultToastError } from '@app/shared/operators/default-toast-error.operator';
import { ApiInstanceService } from '@app/core/api/api-instance.service';
import { AlertsApiRoute, ApiEndpoint } from '@app/core/models/api.models';

@Injectable({
  providedIn: 'root',
})
export class AlertsApiService extends ApiInstanceService {
  readonly endpoint = ApiEndpoint.Notifications;

  updateAlerts(updates: { instanceId: number; cleared?: boolean; read?: boolean }[]): Observable<boolean> {
    return this.patch({
      route: AlertsApiRoute.Instances,
      data: updates,
    }).pipe(
      map(() => true),
      defaultToastError(),
      catchError(() => of(false)),
    );
  }

  getUnreadAlertsCount(customerId: number): Observable<number> {
    return this.getList<Alert>({
      route: AlertsApiRoute.Instances,
      limit: 1,
      filterValues: { customerId, read: false, cleared: false, muted: false },
    }).pipe(
      map((response) => response.meta.pagination.total || 0),
      catchError(() => of(0)),
    );
  }
}
